import {TicketHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";
import {EmailUs} from "../../blocks/emailus/EmailUs";
import {useEffect} from "react";
import {ContactUs} from "../../blocks/contactus/ContactUs";
import {PrimaryButton} from "../../components/button/Button";

export default function ContactPage(){
    return (
        <>
            <TicketHero titles={["Sharing ideas, shaping success.Big ideas for happy employees."]} megaphone={"Let's make something great work together."}>
                <PrimaryButton href={'/jegyek'} primaryText={'Jegy vásárlása'} secondaryText={"Biztosítsd a helyedet"}></PrimaryButton>
            </TicketHero>
            <ContactUs></ContactUs>
            <EmailUs></EmailUs>
            <Footer></Footer>
        </>
    )
}